import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'button-type-button',
    template: `
    <button type="button" *ngIf="!to.iconButton" class="primaryCls" (click)="onClick($event);">{{text}}</button>
    <button pButton pRipple *ngIf="to.iconButton && to.correct" type="button" icon="pi pi-check" class="p-button-rounded p-button-text"></button>
    <button pButton pRipple *ngIf="to.iconButton && !to.correct" type="button" icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text"></button>
    `,
    styles: [
        `
        .primaryCls{
            padding: 10px;
            border-radius: 5px;
            background: #5181FF !important;
            border: 1px solid #3330;
            color: #fff;
            cursor: pointer;
        }

        button.primaryCls:focus{
            border: none !important;
            outline: none !important;
        }

        .p-button.p-button-text{
            color: #537f2d !important;
        }
    `
    ]
})
export class ButtonTypeComponent extends FieldType {
    formControl!: FormControl;
    constructor() {
        super();
    }

    onClick($event: Event) {
        if (this.to.onClick) {
            this.to.onClick($event);
        }
    }

    public get text() { return this.to.text !== undefined ? this.to.text : ''; }
}